// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__1IkR5","header":"PatientBlock_header__2Udzc","label":"PatientBlock_label__1Hs3x","option":"PatientBlock_option__-Ewc6"};